import React from "react";
import { Container, Button } from "react-bootstrap";
import { Link } from "react-router-dom";
import styled from "styled-components";
import { FaCheckCircle } from "react-icons/fa";
import { useGoal } from "./GoalContext";

const StyledContainer = styled(Container)`
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: column;
  height: 70vh;
`;

const TopStyledContainer = styled(Container)`
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: column;
  height: 5vh;
`;

const StyledButton = styled(Button)`
  width: 250px;
  height: 40px;
  font-size: 20px;
`;

const StyledLink = styled(Link)`
  color: white;
  &:hover {
    color: white;
    text-decoration: none;
  }
`;

const StyledCheckMark = styled(FaCheckCircle)`
  color: green;
  font-size: 70px;
`;

const RegisterComplete = (props) => {
  const { goalID } = useGoal();

  return (
    <StyledContainer>
      <h2>無謀な夢の内容を削除しました！</h2>
      <br />
      <StyledCheckMark />
      <h4>
        <br />
        引き続き、無謀な夢への挑戦をお楽しみください。
      </h4>
      <TopStyledContainer></TopStyledContainer>
      <StyledLink to={`/boards/${goalID}`}>
        <StyledButton variant="primary">投稿した夢をみる</StyledButton>
      </StyledLink>
      <br />
      <StyledLink to="/">
        <StyledButton variant="primary">トップページに戻る</StyledButton>
      </StyledLink>
    </StyledContainer>
  );
};

export default RegisterComplete;
